import React, { useEffect } from "react";
import { Modal } from "react-bootstrap";
import { Button, ThemeProviderV2} from '@blueprint/ui';
import { useModal } from "react-modal-hook";

import { LOCAL_STORAGE_KEY } from "../../constants/localStorageKeys";

import useLocalStorage from "./useLocalStorage";

const useAuthErrorPopup = (): void => {
    const [getAuthError, , deleteAuthError] = useLocalStorage(
        LOCAL_STORAGE_KEY.AUTH_ERROR,
    );

    const [show, hide] = useModal(() => {
        const handleClose = () => {
            deleteAuthError();
            hide();
        };

        return (
            <ThemeProviderV2>
            <Modal show onHide={hide} backdrop="static" centered>
                <Modal.Header>
                    <h1 className="mb-0 rem-1-5">Session Ended</h1>
                </Modal.Header>
                <Modal.Body>
                    <p>Your session has expired. Please login again.</p>
                </Modal.Body>

                <Modal.Footer className="d-flex justify-content-end px-3">
                    <Button variant="light.primary" onClick={handleClose}>
                        Dismiss
                    </Button>
                </Modal.Footer>
            </Modal>
            </ThemeProviderV2>
        );
    }, [deleteAuthError]);

    useEffect(() => {
        if (getAuthError()) {
            show();
        }

        return () => {
            hide();
        };
    }, [hide, getAuthError, show]);
};

export default useAuthErrorPopup;
